<template>
    <el-card v-loading="!is_ok" class="page_card" ref="card">
        <el-form :inline="true" ref="selectForm" :model="selectForm" class="demo-form-inline">
            <!-- <el-form-item label="企业名称/简称">
                <el-input placeholder="请输入企业名称/简称" v-model="selectForm.abridge"></el-input>
            </el-form-item> -->

            <!-- :remote-method="selectComMethod" -->
            <el-form-item label="企业名称/简称">
                <el-select
                    v-model="selectForm.abridge"
                    :multiple="false"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入企业名称/简称"
                    @change="changeCom"
                    :loading="is_select">
                    <el-option
                        v-for="item in componys"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="行政区域">
                <el-cascader
                    v-model="selectForm.province"
                    :options="address"
                    :props="props"
                    collapse-tags
                    clearable
                >
                </el-cascader>
            </el-form-item>
            <el-form-item label="企业等级">
                <el-select v-model="selectForm.level" placeholder="请选择" style="width: 80px">
                    <el-option
                        v-for="item in levels"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="销售负责人">
                <el-select v-model="selectForm.uid" placeholder="请选择" style="width: 100px">
                    <el-option
                        v-for="item in sales_users"
                        :key="item.id"
                        :label="item.displayName"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item label="企业类型">
                <el-select v-model="selectForm.type" placeholder="请选择" style="width: 90px">
                    <el-option
                        v-for="item in types"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="selectForm.status" placeholder="请选择" style="width: 90px">
                    <el-option
                        v-for="item in status"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="合同状态">
                <el-select v-model="selectForm.isRelieve" placeholder="请选择" style="width: 90px">
                    <el-option
                        v-for="item in contractStatus"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-checkbox v-model="selectForm.hasCredit">是否有信用额度</el-checkbox>
            </el-form-item>
             <el-form-item label="">
                <el-checkbox v-model="selectForm.hasDiscount">是否有条件优惠</el-checkbox>
            </el-form-item>
            <el-form-item>
                <el-button plain type="primary" :loading="is_post" @click="selectSubmit()">查询</el-button>
                <el-button plain :loading="is_post" @click="resetSelect()">重置</el-button>
                <el-button plain type="success" @click="goToAdd()" v-can="['btn:add_com']">+ 新增企业</el-button>
                <el-button plain type="warning" @click="goLimitPlan()" v-can="['btn:plan_limitation']">限制计划</el-button>
            </el-form-item>
        </el-form>
        <el-table v-loading="is_loading" :data="data" v-if="showtable" stripe :max-height="tableMaxHeight">
            <el-table-column label="企业名称" width='230'>
                <template slot-scope="scope">
                    <el-link :underline="false" @click="editCompany(scope.row)" type="primary">{{scope.row.name}}</el-link>
                </template>
            </el-table-column>
            <!-- <el-table-column label="企业简称" min-width='8%'>
                <template slot-scope="scope">
                    <span class="primary_text">{{ scope.row.abridge }}</span>
                </template>
            </el-table-column>
            <el-table-column label="地址"  min-width='12%'>
                <template slot-scope="scope" >
                    <div>
                        {{getProvince(scope.row)}}
                    </div>
                    <div>
                        {{scope.row.address}}
                    </div>
                </template>
            </el-table-column> -->
             <!-- v-if="userinfo.client||userinfo.client_sub" -->
            <el-table-column label="企业等级" width='150' v-if="showCustomer==true" align="center">
                <template slot-scope="scope">
                    <el-rate
                        v-model="scope.row.level"
                        disabled
                        show-score
                        :show-text="false"
                        text-color="#ff9900"
                        :max="5">
                    </el-rate>
                </template>
            </el-table-column>
            <el-table-column label="企业联系人" align="center" width='155'>
                <template slot-scope="scope">
                    <div>
                        <span class="primary_text">{{ scope.row.contactName }}</span>&nbsp;
                        <span class="primary_text">{{ scope.row.contactMobile }}</span>
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column label="销售负责人" min-width='9%'>
                <template slot-scope="scope">
                    <div v-if="scope.row.uid == 0">
                        <span class="warning_text">暂无负责人</span>
                    </div>
                    <div v-else>
                        <span class="success_text">{{ get_saler_name(scope.row) }}</span>
                    </div>
                </template>
            </el-table-column> -->
            <el-table-column label="余额(元)" align="right" width='130'>
                <template slot-scope="scope">
                    <div v-if="scope.row.balance >= 0">
                        <span class="success_text">{{ parseNums(scope.row.balance) }}</span>
                    </div>
                    <div v-else>
                        <span class="danger_text">{{ parseNums(scope.row.balance) }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="冻结金额(元)" align="right" width='130'>
                <template slot-scope="scope">
                    <span class="danger_text">{{ parseNums(scope.row.freezeBalance) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="合同开始日期" align="center" width='105'>
                <template slot-scope="scope">
                    <span class="primary_text">{{ scope.row.contractStartTime }}</span>
                </template>
            </el-table-column>
            <el-table-column label="合同结束日期" align="center" width='105'>
                <template slot-scope="scope">
                    <span class="primary_text">{{ scope.row.contractEndTime }}</span>
                </template>
            </el-table-column>
            <el-table-column label="最后对账时间" align="center" width='150'>
                <template slot-scope="scope">
                    <span class="primary_text">{{ scope.row.cycleEndDate}}</span>
                </template>
            </el-table-column>

            <el-table-column label="合同状态"  align="center">
                <template slot-scope="scope">
                    <span class="danger_text" size="mini" v-if="scope.row.isRelieve == false && Date.parse(scope.row.contractEndTime) <= new Date()">过期</span>
                    <span class="success_text" size="mini" v-else-if="scope.row.isRelieve == false && Date.parse(scope.row.contractEndTime) > new Date()">执行</span>
                    <span class="danger_text" size="mini" v-else>解除</span>
                </template>
            </el-table-column>
            <el-table-column label="状态"  align="center">
                <template slot-scope="scope">
                    <span class="success_text" size="mini" v-if="scope.row.status == 1">正常</span>
                    <span class="danger_text" size="mini" v-else>禁用</span>
                </template>
            </el-table-column>

            <el-table-column label="备注"  v-if="roles.includes('admin')||roles.includes('seller')||roles.includes('seller_director')" align="center">
                <template slot-scope="scope">
                    <span class="warning_text" v-if="!scope.row.remark.length">无</span>
                    <el-popover
                        v-else
                        placement="top-start"
                        width="200"
                        trigger="hover"
                        :content="scope.row.remark">
                        <el-button slot="reference" plain size="mini" type="primary"><svg-icon icon-class="remark" /></el-button>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column label="操作" width='280' v-if="has_permission('btn:goto_money') || has_permission('btn:edit_company')">
                <template slot-scope="scope">
                    <div style="display: flex;">
                            <el-button type="success" plain :loading="is_post" @click="addItem(scope.row)"  style="padding: 12px 3px;" v-can="['btn:add_money']" :disabled="company=={}?true:false">资金管理</el-button>
                            <el-button type="warning" plain :loading="is_post" @click="editContract(scope.row)" v-can="['btn:contract_editing']" style="padding: 12px 3px;margin-left:8px;">编辑合同</el-button>
                            <el-button type="danger" plain :loading="is_post" @click="del(scope.row)" v-can="['btn:modifying_disable_customer']" v-if="scope.row.status == 1"  style="padding: 12px 3px;margin:0 8px;">账户禁用</el-button>
                            <el-button type="success" plain :loading="is_post" @click="redel(scope.row)" v-can="['btn:modifying_disable_customer']" v-if="scope.row.status == 0"  style="padding: 12px 3px;margin:0 8px;">账户恢复</el-button>
                            <!-- <el-dropdown-item class="danger_text disable-box" style="padding: 0 3px;" command="del" v-can="['btn:edit_disable']" v-if="scope.row.status == 1">
                                <span>
                                账户禁用</span>
                            </el-dropdown-item>
                            <el-dropdown-item class="success_text reset-box" style="padding: 0 3px;" command="redel" v-can="['btn:edit_reply']" v-if="scope.row.status == 0">
                                <i class="el-icon-refresh-left" />
                                恢复
                            </el-dropdown-item> -->
                        <el-dropdown trigger="click" placement="bottom-start" @command="clickDrop($event,scope.row)">

                            <el-button type="primary" size="mini" plain>
                                <svg-icon icon-class="many"/>
                            </el-button>


                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item class="success_text" style="padding: 0 3px;" command="add" v-can="['btn:favorable_terms']">
                                    <svg-icon icon-class="add" />
                                    条件优惠
                                </el-dropdown-item>
                                <el-dropdown-item class="primary_text" style="padding: 0 5px;" command="money" v-can="['btn:goto_money']">
                                    <svg-icon icon-class="financial" />
                                    资金明细
                                </el-dropdown-item>
                                <el-dropdown-item class="warning_text" style="padding: 0 5px;" command="edit" v-can="['btn:edit_company']">
                                    <svg-icon icon-class="change"/>
                                    修改信息
                                </el-dropdown-item>
                                <el-dropdown-item class="info_text" style="padding: 0 5px;" command="lines" v-can="['btn:edit_lines']">
                                    <svg-icon icon-class="money"/>
                                    信用额度
                                </el-dropdown-item>
                                <!-- <el-dropdown-item class="success_text" command="redel" v-can="['btn:edit_reply']" v-if="scope.row.status == 0">
                                    <i class="el-icon-refresh-left" />
                                    恢复
                                </el-dropdown-item> -->
                                <!-- <el-dropdown-item class="danger_text" command="del" v-can="['btn:edit_disable']" v-if="scope.row.status == 1">
                                    <svg-icon icon-class="dis"/>
                                    禁用
                                </el-dropdown-item> -->
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>

                </template>
            </el-table-column>
        </el-table>
        <footer style="height: 50px;position: absolute;bottom: 10px;width: calc(100% - 40px);">
            <el-pagination
                style="float: left;position: relative;top: 10px;"
                @current-change="pageChange"
                :current-page.sync="selectForm.pageNum"
                :page-size="selectForm.pageSize"
                :hide-on-single-page="false"
                layout="prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </footer>
        <el-drawer
            title="备注"
            :visible.sync="remark_dialog"
            direction="rtl"
            size="20%"
        >
            <div style="font-size: 16px;padding: 0 20px" v-if="active_item">
                {{active_item.remark}}
            </div>
        </el-drawer>
        <!-- 限制计划 -->
        <el-dialog title="限制计划" :visible.sync="limit_plan_dialog" width="25%">
            <el-form ref="limitPlanForm" :model="limitPlanForm" label-width="100px"  :rules="limitPlanFormRules">
                 <el-form-item label="今日计划：" style="margin-left:20%;">
                      <el-switch v-model="limitPlanForm.toplan" active-color="#13ce66" inactive-color="#ff4949" active-text="启用限制"
  inactive-text="取消限制" @change="toPlanChange" :disabled='accessLevelt == 1'></el-switch>
                </el-form-item>
                <el-form-item label="明日计划：" style="margin-left:20%;">
                      <el-switch v-model="limitPlanForm.tmplan" active-color="#13ce66" inactive-color="#ff4949" active-text="启用限制"
  inactive-text="取消限制" @change="tmPlanChange" :disabled='accessLevelm == 1'></el-switch>
                </el-form-item>
                <el-form-item label="长期禁用：" style="margin-left:20%;">
                      <el-switch v-model="limitPlanForm.longplan" active-color="#13ce66" inactive-color="#ff4949" active-text="启用限制"
  inactive-text="取消限制" @change="longPlanChange" :disabled='accessLevel == 1'></el-switch>
                </el-form-item>
               <div style="text-align:center;">
                    <el-button type="primary" :loading="is_post" plain @click="limitPlanSubmit()">保 存</el-button>
               </div>
            </el-form>
        </el-dialog>
         <el-dialog title="添加优惠" :visible.sync="isAdd" width="50%">
            <el-button plain type="success" @click="addDiscountOption">添加优惠规则</el-button>
            <el-table border :data="discount_list">
                <el-table-column label="产品名称" >
                    <template slot-scope="scope">
                        <span>
                            {{scope.row.goodsName}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="满足采购量(吨)">
                    <template slot-scope="scope">
                        <span class="primary_text">
                            {{scope.row.conditionNum}} 吨
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="优惠金额">
                    <template slot-scope="scope">
                        <span class="danger_text">
                                - {{scope.row.cutPrice}}元/吨
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="执行周期" width="200">
                    <template slot-scope="scope">
                       {{scope.row.beginDate}} - {{scope.row.endDate}}
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="warning" plain @click="editAllItem(scope.row,scope.$index)"><i class="el-icon-edit" /></el-button>
                        <el-button size="mini" type="danger" plain @click="delAllItem(scope.row,scope.$index)"><i class="el-icon-circle-close" /></el-button>
                    </template>
                </el-table-column>
             </el-table>
         </el-dialog>
         <el-dialog :title="(allFormType == 'add'?'添加':'修改')+'优惠规则'" :visible.sync="add_dialog" width="40%">
            <el-form ref="allForm" :model="allForm" label-width="140px" :rules="allFormRules">
                <el-form-item label="优惠开始日期" prop="beginDate">
                    <el-date-picker
                       style="width:100%"
                        v-model="allForm.beginDate"
                        type="datetime"
                        align="right"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"

                        placeholder="请选择优惠开始日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="优惠结束日期" prop="endDate">
                    <el-date-picker
                       style="width:100%"
                        v-model="allForm.endDate"
                        type="datetime"
                        align="right"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="请选择优惠结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="产品" prop="goodsId">
                    <el-select v-model="allForm.goodsId" placeholder="请选择" style="width:100%">
                        <el-option :label="item.name" :value="item.id" v-for="item of goods_list" :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="满足采购量(吨)" prop="conditionNum">
                    <el-input v-model="allForm.conditionNum" placeholder="满足采购量(吨)"></el-input>
                </el-form-item>
                <el-form-item label="每吨优惠额(元/吨)" prop="cutPrice">
                    <el-input v-model="allForm.cutPrice" placeholder="每吨优惠额(元/吨)"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" v-if="allFormType == 'add'" :loading="is_post" plain @click="addAllItem">保 存</el-button>
                    <el-button type="warning" plain v-if="allFormType == 'edit'" :loading="is_post" @click="editAllItemSave">保 存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <!-- 额度 -->
        <el-dialog title="添加信用额度" :visible.sync="lines_dialog" width="35%">
            <el-card>
                <el-form ref="linesForm" :inline="true" :model="linesForm" label-width="80px" :rules="linesFormRules">
                    <el-form-item label="信用额度" prop="credit">
                        <el-input v-model="linesForm.credit" placeholder="请输入信用额度值"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :loading="is_post" plain @click="linesSubmit()">保 存</el-button>
                    </el-form-item>
                </el-form>
                <div class="table-title" style="margin: 0% 2% 2% 2%;">
                    <div style="margin-bottom:5px;">
                        <span class="bill_title">调整记录</span>
                    </div>
                    <el-table border :data="creditLists" class="bill_detail"
                :header-cell-style='{background:"#F5F7FA",color:"#767676"}'
                        >
                        <el-table-column label="调整时间" width="160" align="center" prop="addTime">

                        </el-table-column>
                        <el-table-column label="操作人" align="center" prop="addUserName">

                        </el-table-column>
                        <el-table-column label="调整前额度" align="center" prop="oldCredit">

                        </el-table-column>
                        <el-table-column label="调整后额度" align="center" prop="newCredit">

                        </el-table-column>
                    </el-table>
                </div>
                <footer style="height: 50px;width: calc(100% - 40px);">
                    <el-pagination
                        style="float: left;"
                        @current-change="pageChangeCredit"
                        :current-page.sync="creditForm.pageNum"
                        :page-size="creditForm.pageSize"
                        :hide-on-single-page="false"
                        layout="prev, pager, next, jumper"
                        :total="creditTotal">
                    </el-pagination>
                </footer>
            </el-card>


        </el-dialog>
        <!-- 增加货款 -->
        <el-dialog
            title="资金管理"
            :visible.sync="add_dialog_zj"
            width="30%"
            >
            <div class="view_section_right_view"  @click="onButtonClick">短信识别</div>
            <el-form ref="addForm" v-if="company" :model="addForm" :rules="rules" label-position="right" label-width="120px">
                <el-form-item label="公司名称" v-if="company">
                    <span class="primary_text">{{company.name}}</span>
                </el-form-item>
                <el-form-item label="开户行" v-if="company">
                    <span class="primary_text">{{company.bankName}}</span>
                </el-form-item>
                <el-form-item label="银行账号" v-if="company">
                    <span class="primary_text">{{company.bankNumber}}</span>
                </el-form-item>
                <el-form-item label="资金方向">
                    <el-radio-group v-model="addForm.inOrOut" @change="intouchange">
                        <el-radio-button label="0">收款</el-radio-button>
                        <el-radio-button label="1">退款</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否调账">
                    <el-radio-group v-model="addForm.adjustment">
                        <el-radio label="0">否</el-radio>
                        <el-radio label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="上账时间" prop="toAccountDate" style="width: 100%" v-show="addForm.adjustment==1">
                   <el-date-picker
                        v-model="addForm.toAccountDate"
                        type="datetime"
                        style="width: 100%"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        format="yyyy-MM-dd HH:mm:ss"
                        placeholder="请选择上账时间">
                    </el-date-picker>
                </el-form-item>
                <!-- <el-form-item label="资金用途">
                    <el-radio-group v-model="addForm.type" >
                        <el-radio-button v-show="addForm.inOrOut==0" label="0">货款</el-radio-button>
                        <el-radio-button v-show="addForm.inOrOut==1" label="1">冲账</el-radio-button>
                        <el-radio-button label="99">其他</el-radio-button>
                    </el-radio-group>
                </el-form-item> -->
                <el-form-item label="其他资金用途" v-if="addForm.type == '99'" prop="other">
                    <el-input v-model="addForm.other" placeholder="请填写其他资金用途"  maxlength="20" show-word-limit :rules="[{ required: true, message: '请输入其他资金用途', trigger: 'blur' }]"></el-input>
                </el-form-item>

                <el-form-item label="上期余额(元)" v-if="company">
                    <span class="warning_text">{{company.balance}}</span>
                </el-form-item>
                <el-form-item label="金额(元)" prop="money">
                    <el-input v-model="addForm.money" type="number" @blur="headblur" placeholder="请输入操作金额,最多保留2位小数"></el-input>
                </el-form-item>
                <el-form-item label="本期余额(元)">
                    <span class="danger_text">{{endMoney}}</span>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="addForm.remark"
                        maxlength="100"
                        show-word-limit
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" @click="addSubmit()" plain :loading="is_post">提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <!-- 智能识别 -->
            <el-dialog title="智能识别" :visible.sync="ismoney" width="35%" @close='handleCancle'>
                <div class="box-title">
                    <span>智能输入短信信息</span>
                </div>
                <div>
                    <el-input v-model="inputVal" @input="smartInput" @change="btnInput" class="textarea-box" :autosize="{ minRows: 6, maxRows: 12}" placeholder-class="remark-box" type="textarea" maxlength="50000"  placeholder="请输入短信信息"></el-input>
                </div>
                <div class="btn-box">
                    <div @click="resetBtn" class="btn-common btn-reset">清空</div>
                    <div @click="btnClick" class="btn-common btn-identify">识别</div>
                </div>
        </el-dialog>
        <!-- 编辑合同 -->
        <el-dialog :visible.sync="isEditContract" title="修改合同" width="30%">
           <el-form :model="editForm" ref="editForm" :rules='rulesEditContract' label-width="160px">
                <el-form-item label="合同起始时间" prop="contractStartTime">
                    <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="editForm.contractStartTime" type="date" placeholder="开始时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="合同到期时间" prop="contractEndTime">
                    <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="editForm.contractEndTime" type="date" placeholder="到期时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="合同状态">
                    <el-radio-group v-model="editForm.isRelieve" @change="changeRelieve">
                        <el-radio :label="true">解除合同</el-radio>
                        <el-radio :label="false">执行合同</el-radio>
                    </el-radio-group>
                      <!-- <el-switch @change='changeRelieve' v-model="editForm.isRelieve" inactive-color="#13ce66" active-color="#ff4949" inactive-text="续约合同" active-text="解除合同" style="margin-left:0"></el-switch> -->
                </el-form-item>
                <el-form-item label="">
                    <el-button plain type="primary" @click="editSubmit()">保 存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </el-card>
</template>

<script>
import request from '@/utils/request'
import can from "@/directive/can/index.js"
import {stringTrim} from '@/utils/elvalid'
import {mapGetters} from 'vuex'
import {addCount,subCount} from '@/utils/calculation'
import {date} from "mockjs/src/mock/random/date";

export default {
    name: 'customer_company',
    directives:{can},
    computed:{
        ...mapGetters([
            'permissions',
            'roles',
        ])
    },
    data() {
        let validateMoney =  (rule, value, callback)=>{
            if(this.addForm.inOrOut == 0){
                //增加
                if(parseFloat(value) > 100000000){
                    callback(new Error("打款金额不能超过1亿!"));
                }else{
                    callback();
                }
            }else{
                if(parseFloat(value) > parseFloat(this.company.balance)){
                    callback(new Error("扣款金额不能超过该账户余额!"));
                }else{
                    callback();
                }
            }
        }
        return {
            remark_dialog:false,
            active_item:null,
            is_ok: false,
            is_post: false,
            data: [],
            showtable: false,
            tableMaxHeight: 0,
            is_loading:false,
            selectForm: {
                abridge: '',
                province: [],
                level: 'all',
                uid: 'all',
                type: 'all',
                status: 'all',
                isRelieve:'all',
                hasCredit:false,
                hasDiscount:false,
                pageNum: 1,
                pageSize: 10
            },
            ismoney:false,
            inputVal:'',
            isAdd:false,
            allFormType:'add',
            add_dialog:false,
            allForm:{
                goodsId:'',
                conditionNum:'',
                cutPrice:'',
                comId:0,
                beginDate: '',
                endDate: '',
            },
            goods_list:[],
            discount_list:[],
            address: [],
            levels: [
                { id: 'all', label: '全部' },
                { id: 1, label: '一级' },
                { id: 2, label: '二级' },
                { id: 3, label: '三级' },
                { id: 4, label: '四级' },
                { id: 5, label: '五级' }
            ],
            sales_users: [
                { id: 'all', displayName: '全部' }
            ],
            status: [
                { id: 'all', label: '全部' },
                { id: 0, label: '禁用' },
                { id: 1, label: '正常' }
            ],
            contractStatus: [
                { id: 'all', label: '全部' },
                { id: 0, label: '解除' },
                { id: 1, label: '执行' }
            ],
            types: [
                { id: 'all', label: '全部' },
                {id:0,label:"贸易商"},
                {id:1,label:"加气站"},
                {id:2,label:"终端客户"},
                {id:3,label:"物流公司"}
            ],
            props: { multiple: true, checkStrictly: true },
            total:0,
            lines_dialog:false,
            limit_plan_dialog:false,
            linesForm:{
                credit:"",
                comId:''
            },
            linesFormRules:{
                credit:[
                    { required: true, message: '请输入信用额度值', trigger: 'blur' },
                    { pattern:/^[0-9]\d*$/ ,message:"请输入一个正整数",trigger:"blur" }
                ]
            },
            limitPlanForm:{
                toplan:false,
                tmplan:false,
                longplan:false
            },
            accessLevelt:'0',
            accessLevelm:'0',
            accessLevel:'0',
            limitPlanFormRules:{

            },
            allFormRules:{
                beginDate:[{ required: true, message: '请选择优惠开始日期', trigger: 'blur' }],
                endDate:[{ required: true, message: '请选择优惠结束日期', trigger: 'blur' }],
                goodsId:[{ required: true, message: '请选择产品名称', trigger: 'blur' },],
                conditionNum:[
                    { required: true, message: '请输入满足采购量', trigger: 'blur' },
                    { pattern:/^[1-9]\d*$/ ,message:"请输入一个正整数",trigger:"blur" }
                ],
                cutPrice:[
                    { required: true, message: '请输入要优惠的价格', trigger: 'blur' },
                    { pattern:/^[1-9]\d*$/ ,message:"请输入一个正整数",trigger:"blur" }
                ]
            },
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            //公司信息
            company:{},
            componys: [],
            is_select:false,
            add_dialog_zj:false,
            addForm:{
                comId:"",
                inOrOut:0,
                adjustment:'0',
                toAccountDate:'',
                type:0,
                money:"",
                remark:"",
                other:""
            },
            rules:{
                money:[
                    { required: true, message: '请输入金额', trigger: 'blur' },
                    { pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/, message: '请输入一个正整数,最多保留2位小数', trigger: 'blur' },
                    { validator: validateMoney, trigger: 'blur' },
                ],
                other:[
                    { required: true, message: '请填写其他资金用途', trigger: 'blur' },
                    { validator: stringTrim, trigger: 'blur' }
                ]
            },
            endMoney:"",
            endMoneyNew:"",
            showCustomer:true,
            isEditContract:false,
            editForm:{
                customer_get_by_uid:'0',
                comId:'',
                contractStartTime:'',
                contractEndTime:'',
                isRelieve:null
            },
            rulesEditContract:{
                contractStartTime:[
                    { required: true, message: '请选择合同起始时间', trigger: 'blur' },
                ],
                contractEndTime:[
                    { required: true, message: '请选择合同结束时间', trigger: 'blur' },
                ],
            },
            creditLists:[],
            creditForm:{
                comId:'',
                pageNum: 1,
                pageSize: 10
            },
            creditTotal:0,

        }
    },
    methods: {
        date,
        getCompany(){
            request.get("company/option").then(res=>{
                this.componys = res.data;
            }).catch(err=>{
            });
        },
        changeCom(e){
            this.selectForm.abridge=e;
            this.getData();
        },
        toPlanChange(e){
            this.limitPlanForm.toplan=e;
            if(this.limitPlanForm.toplan==true||this.limitPlanForm.tmplan==true){
                this.accessLevel='1';
                this.limitPlanForm.longplan=false;
            }else{
                this.accessLevel='0';
            }
        },
        tmPlanChange(e){
            this.limitPlanForm.tmplan=e;
            if(this.limitPlanForm.tmplan==true||this.limitPlanForm.toplan==true){
                this.accessLevel='1';
                this.limitPlanForm.longplan=false;
            }else{
                this.accessLevel='0';
            }
        },
        longPlanChange(e){
            this.limitPlanForm.longplan=e;
            if(this.limitPlanForm.longplan==true){
                this.limitPlanForm.toplan=false;
                this.limitPlanForm.tmplan=false;
                this.accessLevelt='1';
                this.accessLevelm='1';
            }else{
                this.accessLevelt='0';
                this.accessLevelm='0';
            }
        },
        getOrderDisable(){
            request.get('order_disable/get').then(res=>{
                if(res.code==200){
                    this.limitPlanForm.toplan=res.data.today;
                    this.limitPlanForm.tmplan=res.data.tomorrow;
                    this.limitPlanForm.longplan=res.data.all;
                }
                if(this.limitPlanForm.longplan==true){
                    this.accessLevelt='1';
                    this.accessLevelm='1';
                }else if(this.limitPlanForm.tmplan==true||this.limitPlanForm.toplan==true){
                    this.accessLevel='1';
                }
            })
        },
        parseNums(n,is_int=false) {
            //转化成字符串
            let str = n.toString();
            //若是整数自动补全小数位
            if (-1 == str.indexOf(".")) {
                str = str + ".00"
            }
            if(str.indexOf(".")!=-1){
                let x = str.indexOf('.') + 1;   //小数点的位置
                let y = str.length - x;  //小数的位数
                if(y > 0 && y == 1){
                    str = str + "0"
                }
            }
            //全部替换
            if (-1 != str.indexOf(",")) {
                str = str.replace(new RegExp(',', "g"), "")
            }
            let intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分
            if(is_int){
                return intSum;
            }
            let dot = str.substring(str.length, str.indexOf("."))//取到小数部分搜索
            let ret = intSum + dot;
            return ret;
        },
        limitPlanSubmit(){
            var params=[{
                    "enable": this.limitPlanForm.toplan,
                    "type": 0
                },{
                    "enable": this.limitPlanForm.tmplan,
                    "type": 1
                },{
                    "enable": this.limitPlanForm.longplan,
                    "type": 2
                }];
            request.post('order_disable/enable',params).then(res=>{
                if(res.code==200){
                    this.$message.success("限制计划成功!");
                    this.limit_plan_dialog=false;
                }
            })
        },
        btnInput(){},
        smartInput(e){
            this.inputVal = e.toUpperCase()
        },
        handleCancle(){

        },
        changeRelieve(e){

        },
        editContract(e){
            this.isEditContract=true;
            this.editForm.contractStartTime=e.contractStartTime;
            this.editForm.contractEndTime=e.contractEndTime;
            this.editForm.isRelieve=e.isRelieve;
            // if(e.isRelieve==false){
            //     this.editForm.isRelieve=true;
            // }else{
            //     this.editForm.isRelieve=false;
            // }
            this.editForm.id=e.id;
            this.editForm.comId=e.id;
        },
        //编辑合同保存
        editSubmit(){
            this.$refs["editForm"].validate((valid)=>{
                if(!valid) return false;
                request.post('/contract/edit',this.editForm).then(res=>{
                    if(res.code=='200'){
                        this.$message.success('修改合同成功！')
                        this.editForm.contractStartTime='';
                        this.editForm.contractEndTime='';
                        this.editForm.isRelieve=null;
                        this.isEditContract=false;
                        this.getData()
                    }else{
                        this.$message.error(res.msg)
                    }
                })
        })

        },
        //智能识别
        onButtonClick(){
             this.ismoney=true;
        },
        //识别
        btnClick(){
            if(this.inputVal==''){
                this.$message.error('识别内容不能为空')
            }else{
                if(this.inputVal.indexOf('中国农业银行')!==-1){
                    let s=this.inputVal
                    let cm=s.split('向')[1]
                    let mn=cm.split('金额为')[1]
                    // this.company=cm.split('完成')[0]
                    this.addForm.money=mn.split('，')[0]
                }else if(this.inputVal.indexOf('贵公司')!==-1){
                    let s=this.inputVal
                    let cm=s.split('人民币')[1]
                    this.addForm.money=cm.split('元')[0]
                    let mn=s.split("对方户名:")[1]
                    // this.company=mn.split('。')[0]
                }else{
                    this.$message.error('无法识别关键信息！')
                }
                this.ismoney=false;
                this.inputVal=''
                if(this.addForm.inOrOut==0){
                    this.endMoney=(parseFloat(this.endMoney)+parseFloat(this.addForm.money)).toFixed(2)
                }else{
                     this.endMoney=(parseFloat(this.endMoney)-parseFloat(this.addForm.money)).toFixed(2)
                }

            }
        },
        //清除
        resetBtn(){
            this.inputVal=''
        },
        addItem(data){
            this.company=data;
            this.company.balance = data.balance.toFixed(2)
            this.addForm.comId = data.id;
            //防止下次弹框数据还保留上次的
            this.addForm.money='';
            this.getEndMoney();
            this.add_dialog_zj = true;

        },
        getEndMoney(){
            if(!this.company || typeof this.company.balance == "undefined"){
                this.endMoney="";
            }
            if(this.addForm.inOrOut == 0){
                //增加
                if(this.addForm.money && this.addForm.money.length > 0 && typeof parseFloat(this.addForm.money) == "number"){
                    this.endMoney= parseFloat(this.company.balance) + parseFloat(this.addForm.money);
                    this.endMoneyNew= parseFloat(this.company.balance) + parseFloat(this.addForm.money);
                }else{
                    this.endMoney=this.company.balance;
                    this.endMoneyNew=this.company.balance;

                }
            }else if(this.addForm.inOrOut == 1){
                //减少
                if(this.addForm.money && this.addForm.money.length > 0 && typeof parseFloat(this.addForm.money) == "number"){
                    this.endMoney=parseFloat(this.company.balance) - parseFloat(this.addForm.money);
                     this.endMoneyNew=parseFloat(this.company.balance) - parseFloat(this.addForm.money);
                }else{
                    this.endMoney=this.company.balance;
                    this.endMoneyNew=this.company.balance;
                }
            }
        },
        intouchange(inout){
            if(this.addForm.type != 99){
                if(inout == 1){
                    this.addForm.type = 1;
                }else if(inout == 0){
                    this.addForm.type = 0;
                }
            }

            if(this.addForm.inOrOut==0){
                // this.endMoney=parseFloat(this.endMoney)+parseFloat(this.addForm.money==''?'0':this.addForm.money)
                this.endMoney=addCount(parseFloat(this.endMoneyNew),parseFloat(this.addForm.money==''?'0':this.addForm.money));
            }else{
                // this.endMoney=parseFloat(this.endMoney)-parseFloat(this.addForm.money==''?'0':this.addForm.money)
                this.endMoney = subCount(parseFloat(this.endMoneyNew),parseFloat(this.addForm.money==''?'0':this.addForm.money));
            }
        },
        headblur(){
            if(this.addForm.inOrOut==0){
                this.endMoney = addCount(parseFloat(this.endMoneyNew),parseFloat(this.addForm.money==''?'0':this.addForm.money));
                // this.endMoney=parseFloat(this.endMoneyNew)+parseFloat(this.addForm.money==''?'0':this.addForm.money)
            }else{
                this.endMoney = subCount(parseFloat(this.endMoneyNew),parseFloat(this.addForm.money==''?'0':this.addForm.money));
                // this.endMoney=parseFloat(this.endMoneyNew)-parseFloat(this.addForm.money==''?'0':this.addForm.money)
            }
        },
        addSubmit(){
            this.$refs["addForm"].validate((valid)=>{
                if(!valid) return false;
                // if((this.addForm.type == 0 && this.addForm.inOrOut == 1) || (this.addForm.type == 1 && this.addForm.inOrOut == 0)){
                //     this.$message.warning("资金冲账类型必须选择扣款方向");
                //     return false;
                // }
                // if(this.addForm.type == 0 && this.addForm.inOrOut == 1){
                //     this.$message.warning("货款冲账类型必须选择打款方向");
                //     return false;
                // }
                if(this.addForm.adjustment == '1'&&this.addForm.toAccountDate == ''){
                    this.$message.warning("请选择上账时间");
                    return false;
                }
                if(this.addForm.adjustment == '1'&&this.addForm.remark == ''){
                    this.$message.warning("请输入备注");
                    return false;
                }
                this.is_post = true;
                request.post("finance/add_balance_record",this.addForm).then(res=>{
                    this.addForm.inOrOut = 0;
                    this.addForm.toAccountDate = '';
                    this.addForm.money = "";
                    this.addForm.remark = "";
                    this.addForm.type =0;
                    this.addForm.adjustment='0';
                    this.addForm.other = "";
                    this.add_dialog_zj = false;
                    // this.data.unshift(res.data);
                    this.$message.success("新增财务明细成功!");
                    this.is_post = false;
                    this.getData();
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        editCompany(item){
            if(!this.has_permission("btn:edit_company")){
                return false;
            }
            this.$router.push({name:"edit_company",params:{id:item.id}});
        },
        clickDrop(e, item) {
            if(e == "edit"){
                this.$router.push({name:"edit_company",params:{id:item.id}});
            }else if(e=='add'){
                this.isAdd=true;
                this.allForm.comId=item.id
                this.discount_lis
                this.getDataList()
            }else if(e == "money"){
                this.$router.push({name:"financial_list",query:{id:item.id}});
            }
            // else if(e == "del"){
            //     this.is_post = true;
            //     request.post("company/change_status",{id:item.id,status:0}).then(res=>{
            //         this.$message.success("操作成功");
            //         item.status = 0;
            //         this.is_post = false;
            //     }).catch(err=>{
            //         this.is_post = false;
            //     });
            // }else if(e == "redel"){
            //     this.is_post = true;
            //     request.post("company/change_status",{id:item.id,status:1}).then(res=>{
            //         this.$message.success("操作成功");
            //         item.status = 1;
            //         this.is_post = false;
            //     }).catch(err=>{
            //         this.is_post = false;
            //     });
            // }
            else if(e=='lines'){
                this.lines_dialog=true;
                this.linesForm.comId=item.id;
                this.linesForm.credit=item.credit;
                this.creditForm.comId=item.id;
                this.getCreditList();
            }
        },
        del(item){
            this.is_post = true;
            request.post("company/change_status",{id:item.id,status:0}).then(res=>{
                this.$message.success("操作成功");
                item.status = 0;
                this.is_post = false;
            }).catch(err=>{
                this.is_post = false;
            });
        },
        redel(item){
            this.is_post = true;
            request.post("company/change_status",{id:item.id,status:1}).then(res=>{
                this.$message.success("操作成功");
                item.status = 1;
                this.is_post = false;
            }).catch(err=>{
                this.is_post = false;
            });
        },
        pageChange(page){
            this.selectForm.pageNum = page;
            this.getData(false);
        },
        loadAddress() {
            if (window.pandc) {
                this.address = pandc
                return false
            }
            let el = document.createElement('script')
            el.src = '/address.js'
            el.onload = () => {
                this.address = window.pandc
            }
            document.getElementsByTagName('head')[0].appendChild(el)
        },
        selectSubmit() {
            this.getData(false);
        },
        resetSelect(){
            this.selectForm= {
                abridge: '',
                province: [],
                level: 'all',
                uid: 'all',
                type: 'all',
                status: 'all',
                isRelieve:'all',
                pageNum: 1,
                pageSize: 10
            };
            this.$refs["selectForm"].resetFields();
            this.getData(false);
        },

        goToAdd() {
            this.$router.push({name:'add_company'});
        },
        goLimitPlan() {
            this.limit_plan_dialog=true;
            this.getOrderDisable();
        },
        getData(is_init = false){
            if(!is_init){
                this.is_loading = true;
                this.is_post = true;
            }
            request.post("company/list",this.selectForm).then(res=>{
                this.total = res.data.total;
                this.data = res.data.list;
                this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-85;
                this.showtable = true
                if(!is_init){
                    this.is_post = false;
                    this.is_loading = false;
                }else{
                    this.is_ok = true;
                }
            }).catch(err=>{
                this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-85;
                this.showtable = true
                if(!is_init){
                    this.is_post = false;
                    this.is_loading = false;
                }else{
                    this.is_ok = true;
                }
            });
        },
        getSalers(){
            return new Promise((resolve, reject)=>{
                request.get("company/sellers_option").then(res=>{
                    this.sales_users = this.sales_users.concat(res.data);
                    resolve();
                }).catch(err=>{
                    reject(err);
                });
            });
        },
        has_permission(permission){
            return this.permissions.includes(permission);
        },
        get_saler_name(item){
            let res = "";
            for(let user of this.sales_users){
                if(item.uid == user.id){
                    res = user.displayName;
                    break;
                }
            }
            return res;
        },
        getProvince(item){
            let arr = [];
            for(let p of this.address){
                if(p.value == item.province){
                    arr.push(p.label);
                    for(let city of p.children){
                        if(city.value == item.city){
                            arr.push(city.label);
                            for(let co of city.children){
                                if(co.value == item.county){
                                    arr.push(co.label);
                                    break;
                                }
                            }
                            break;
                        }
                    }
                    break;
                }
            }
            return arr.length > 0?arr.join(" "):"";
        },
        showRemark(item){
            this.active_item = item;
            this.remark_dialog = true;
        },
        //额度提交
        linesSubmit(){
            this.$refs['linesForm'].validate(values=>{
                if(!values) return false;
                request.post('/finance/edit_credit',this.linesForm).then(res=>{
                    if(res.code==200){
                        this.$message.success('添加信用额度成功')
                        this.lines_dialog=false;
                    }
                })
                .catch(err=>{
                    this.$message.error('信用额度添加失败')
                })
            })
        },

        // 添加全局优惠
        addDiscountOption(){
            this.add_dialog=true;
            this.allFormType='add';
            this.allForm.goodsId='';
            this.allForm.conditionNum='';
            this.allForm.cutPrice='';
            let current=new Date();
            let y=current.getFullYear();
            let m=current.getMonth()+1 < 10 ? '0'+(current.getMonth()+1) : current.getMonth()+1;
            let preDate = new Date(new Date(y + '-' + m + '-' + '01').getTime() - 86400000);
            let preMonth = preDate.getMonth()+1 < 10 ? '0'+(preDate.getMonth()+1) : preDate.getMonth()+1;
            this.allForm.beginDate= preDate.getFullYear() + "-" + preMonth + `-26 08:00:00`;
            this.allForm.endDate=  y + '-'+ m + '-26 07:59:59'; ;
        },

        //优惠列表
        getDataList(){
            request.get('dis_opt/list?comId='+this.allForm.comId).then(res=>{
                if(res.code==200){
                    this.discount_list=res.data

                }
            })
        },
        //优惠添加
        addAllItem(){
             this.$refs["allForm"].validate(valid=>{
                if(!valid) return false;
                 request.post('dis_opt/create',this.allForm).then(res=>{
                     if(res.code==200){
                         this.$message.success('添加成功')
                         this.add_dialog=false;
                         this.getDataList();
                     }
                 })
             })
        },
        //优惠修改保存
        editAllItemSave(){
            this.$refs["allForm"].validate(valid=>{
                if(!valid) return false;
                 request.post('dis_opt/edit',this.allForm).then(res=>{
                     if(res.code==200){
                         this.$message.success('修改成功')
                         this.add_dialog=false;
                     }
                 })
             })
        },
        //修改
        editAllItem(item,i){
            this.allFormType='edit';
            this.allForm.goodsId=item.goodsId;
            this.allForm.beginDate=item.beginDate;
            this.allForm.endDate=item.endDate;
            this.allForm.conditionNum=item.conditionNum;
            this.allForm.cutPrice=item.cutPrice;
            this.allForm.id=item.id;
            this.allForm.comId=item.comId;
            this.add_dialog=true;

        },
        //删除
        delAllItem(item,index){
            request.post('dis_opt/delete?id='+item.id).then(res=>{
                if(res.code==200){
                    this.$message.success('删除成功');
                    this.getDataList();
                }
            })
        },
        //获取产品列表
         getGoodsList(){
            request.get("goods/dropdown").then(res=>{
                this.goods_list = this.goods_list.concat(res.data);
            }).catch(err=>{
                console.log(err);
            });
        },
        // 信用额度记录
        getCreditList(){
            request.post("company/credit_list",this.creditForm).then(res=>{
                this.creditTotal = res.data.total;
                this.creditLists=res.data.list;
            }).catch(err=>{
                this.$message.error(res.message)
            });
        },
        pageChangeCredit(page){
            this.creditForm.pageNum = page;
            this.getCreditList();
        },

    },
    async created() {
        await this.getSalers();
    },
    mounted() {
        //获取所有地址信息
        this.loadAddress()
        this.getGoodsList();
        this.getData(true);
        this.getCompany();
        if(this.roles.length>0){
            for (let i = 0; i < this.roles.length; i++) {
                if(this.roles[i]=='client'||this.roles[i]=='client_sub'){
                    this.showCustomer=false;
                }
            }
        }
    }
}
</script>

<style scoped>
  .el-dropdown{
    display: flex;
  }
  .disable-box{
    border: 1px solid;
    background: #fdf2f2;
    border-radius: 4px;
    margin-left: 4%;
}
.disable-box:hover{
    background-color: red;
    color: #fff;
}
.reset-box{
    border: 1px solid;
    background: #fdf2f2;
    border-radius: 4px;
    margin-left: 4%;
}
.reset-box:hover{
    background-color: #28c76f;
    color: #fff;
}
.view_section_right_view {
        padding: 9px 0px;
        background: #1890ff;
        border-radius: 8px;
        margin-left: 78%;
        margin-bottom: 3%;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        display: flex;
        justify-content: center;
        font-weight: 400;
        color: #ffffff;
        width: 90px;
    }
    .box{
        padding: 5%;
    }
    .textarea-box{
        width: 90%;
    }
    .remark-box{
        color: #9a9898
    }
    .btn-box{
        display: flex;
        justify-content: space-around;
        font-size: 18px;
    }
    .btn-common{
        width: 18%;
        padding: 10px;
        border-radius: 10px;
        text-align: center;
        margin-top: 15%;
    }
    .btn-reset{
        background:#DCDCDC;
    }
    .btn-identify{
        background:#658bef;
        color: #ffffff;
    }
    .box-title{
        font-size: 18px;
        margin-bottom: 3%;
    }
</style>
